const TIME_UNAVAILABLE = 'Time unavailable'
const timeZone = 'America/New_York'
const timeFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone, hour: 'numeric', minute: '2-digit', hour12: true,
})
const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone, year: 'numeric', month: 'short', day: 'numeric',
  hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true, timeZoneName: 'short',
})
const calendarDateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'UTC', year: 'numeric', month: 'short', day: 'numeric',
})
const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/
const isoTimestampPattern = /^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?(Z|[+-]\d{2}:\d{2})$/i
const businessDateFields = new Set(['date', 'datepaid', 'duedate', 'receivedbydate', 'workdate'])
const isTimestampField = key => /At$/.test(key) || key.toLowerCase() === 'timestamp'

// Round-trip the calendar component because Date otherwise rolls February 30 into March.
const parseCalendarDate = value => {
  if (typeof value !== 'string' || !isoDatePattern.test(value)) return null
  const date = new Date(`${value}T00:00:00.000Z`)
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? date : null
}

const parseTimestamp = value => {
  if (value instanceof Date) return Number.isFinite(value.getTime()) ? value : null
  if (typeof value === 'number') {
    const date = new Date(value)
    return Number.isFinite(date.getTime()) ? date : null
  }
  if (typeof value !== 'string') return null
  // Require an explicit offset so the computer's own timezone cannot alter a log entry.
  const match = value.match(isoTimestampPattern)
  if (!match || !parseCalendarDate(match[1]) || +match[2] > 23 || +match[3] > 59 || +(match[4] || 0) > 59) return null
  const date = new Date(value)
  return Number.isFinite(date.getTime()) ? date : null
}

export const formatActivityTime = value => {
  const date = parseTimestamp(value)
  return date ? `${timeFormatter.format(date)} ET` : TIME_UNAVAILABLE
}

export const formatActivityDateTime = value => {
  const date = parseTimestamp(value)
  return date ? dateTimeFormatter.format(date) : TIME_UNAVAILABLE
}

const normalizeActivityValue = (value, key) => {
  if (Array.isArray(value)) return value.map(item => normalizeActivityValue(item, key))
  if (value && typeof value === 'object' && !(value instanceof Date)) {
    return Object.fromEntries(Object.entries(value).map(([nestedKey, item]) => [nestedKey, normalizeActivityValue(item, nestedKey)]))
  }
  if (businessDateFields.has(key.toLowerCase())) {
    const source = value instanceof Date && Number.isFinite(value.getTime()) ? value.toISOString() : value
    // Business dates sometimes arrive as midnight ISO timestamps. Keep their calendar day.
    const datePart = typeof source === 'string' && (isoDatePattern.test(source) || isoTimestampPattern.test(source)) ? source.slice(0, 10) : null
    const date = parseCalendarDate(datePart)
    return date ? calendarDateFormatter.format(date) : TIME_UNAVAILABLE
  }
  if (isTimestampField(key) || value instanceof Date || (typeof value === 'string' && isoTimestampPattern.test(value))) {
    return formatActivityDateTime(value)
  }
  if (typeof value === 'string' && isoDatePattern.test(value)) {
    const date = parseCalendarDate(value)
    return date ? calendarDateFormatter.format(date) : TIME_UNAVAILABLE
  }
  return value
}

export const formatActivityValue = (value, key = '') => {
  const normalized = normalizeActivityValue(value, key)
  return normalized !== null && typeof normalized === 'object'
    ? JSON.stringify(normalized, null, 2)
    : String(normalized)
}
